import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { Button } from "../Button";

type Step1StartProps = {
  onStart: () => void;
  loading: boolean;
  error?: string;
};
import { I18n } from "react-redux-i18n";

export default function Step1Start({
  onStart,
  loading,
  error,
}: Step1StartProps) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {I18n.t("profile.mfa.activate.step1.title")}
      </Text>
      <Text style={styles.desc}>
        {I18n.t("profile.mfa.activate.step1.description")}
      </Text>
      {!!error && <Text style={styles.error}>{error}</Text>}
      <View style={styles.buttonRow}>
        <Button type="primary" onPress={onStart} disabled={loading}>
          {I18n.t("profile.mfa.activate.step1.setup")}
        </Button>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { alignItems: "center", padding: 16 },
  title: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 8,
  },
  desc: { textAlign: "center", marginBottom: 25, color: "dimgray" },
  error: { color: "crimson", marginBottom: 12 },
  buttonRow: { flexDirection: "row", gap: 12 },
});
